export default __webpack_public_path__ + "static/media/fold.b9a06198.wav";